import PublicForm from './PublicForm.vue';
import AcountPublicForm from './AcountPublicForm.vue';
// import Confirmation from './Confirmation';
// import Signup from './Signup';
// import PasswordEdit from './PasswordEdit';
import { frontendURL } from '../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('forms'),
      name: 'forms',
      component: PublicForm,
      children: [
        // {
        //   path: 'confirmation',
        //   name: 'auth_confirmation',
        //   component: Confirmation,
        //   props: route => ({
        //     config: route.query.config,
        //     confirmationToken: route.query.confirmation_token,
        //     redirectUrl: route.query.route_url,
        //   }),
        // },
        // {
        //   path: 'password/edit',
        //   name: 'auth_password_edit',
        //   component: PasswordEdit,
        //   props: route => ({
        //     config: route.query.config,
        //     resetPasswordToken: route.query.reset_password_token,
        //     redirectUrl: route.query.route_url,
        //   }),
        // },
        // {
        //   path: 'signup',
        //   name: 'auth_signup',
        //   component: Signup,
        //   meta: { requireSignupEnabled: true },
        // },
        {
          path: ':account_id/:form_slug',
          name: 'account_public_form',
          component: AcountPublicForm,
        },
      ],
    },
  ],
};
